import api from 'config/Api/Api';

const baseEndpoint = 'v1/account';

export default {
  getMyAccount() {
    return api.get( 'v1/account-me' );
  },

  verifyPhoneCode( id, data ) {
    return api.put( `${baseEndpoint}/${id}/check-phone-number`, data );
  },

  updateAccount( id, data ) {
    return api.put( `${baseEndpoint}/${id}/data`, data );
  },
};
